import React, { useState } from "react";
import { Box, Container, Tab, Tabs, Typography } from "@mui/material";
import MemoryIcon from "@mui/icons-material/Memory";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import { useTranslation } from "react-i18next";
import color from "../../Constants/colors";
import HardwareMonitoring from "../HardwareMonitoring/HardwareMonitoring";
import DockerServicesMonitoring from "./DockerServicesMonitoring";

const SystemMonitoring: React.FC = () => {
  const { t } = useTranslation("monitoring");
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: color.primary }}>
      <Box
        sx={{
          backgroundColor: color.white,
          borderBottom: `1px solid ${color.gray200}`,
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", pt: 3 }}>
            <Typography
              sx={{
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 700,
                fontSize: "1.75rem",
                color: color.secondary,
              }}
            >
              {t("systemMonitoringTitle")}
            </Typography>
          </Box>
          <Tabs
            value={tab}
            onChange={(_e, value) => setTab(value)}
            centered
            sx={{
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 700,
                fontSize: "0.9rem",
                color: color.gray500,
                minHeight: 56,
              },
              "& .Mui-selected": { color: `${color.secondary} !important` },
              "& .MuiTabs-indicator": { backgroundColor: color.accent, height: 3 },
            }}
          >
            <Tab
              icon={<MemoryIcon sx={{ fontSize: "1.1rem" }} />}
              iconPosition="start"
              label={t("hostTab")}
            />
            <Tab
              icon={<ViewModuleIcon sx={{ fontSize: "1.1rem" }} />}
              iconPosition="start"
              label={t("dockerTab")}
            />
          </Tabs>
        </Container>
      </Box>

      {tab === 0 ? <HardwareMonitoring /> : <DockerServicesMonitoring />}
    </Box>
  );
};

export default SystemMonitoring;
